const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
const REVEAL_ATTRIBUTE = 'data-pimosfer-reveal';

function revealImmediately(section) {
  section.classList.add('is-pimosfer-visible');
}

function prepareHomepageMotion() {
  const main = document.querySelector('#MainContent[data-template="index"]');

  if (!main) return;

  const sections = Array.from(main.children).filter((element) => element.classList.contains('shopify-section'));
  const revealSections = sections.slice(2).filter((section) => !section.querySelector('.pimosfer-why'));

  if (window.matchMedia(REDUCED_MOTION_QUERY).matches || !('IntersectionObserver' in window)) {
    revealSections.forEach(revealImmediately);
    return;
  }

  document.documentElement.classList.add('pimosfer-motion-ready');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        revealImmediately(entry.target);
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.12,
      rootMargin: '0px 0px -8% 0px',
    }
  );

  revealSections.forEach((section) => {
    section.setAttribute(REVEAL_ATTRIBUTE, '');
    observer.observe(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', prepareHomepageMotion, { once: true });
} else {
  prepareHomepageMotion();
}
